module.exports = __webpack_public_path__ + "img/gb-nir.bea2c63.svg";